import React from 'react'
import ListItemButton, { ListItemButtonProps } from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import ColorSwitch from './ColorSwitch'

type Props = ListItemButtonProps & {
  checked?: boolean
  color?: string
  primary?: string
  onClick: (checked: boolean) => void
}

const ToggleListItem: React.FC<Props> = ({ checked, color, primary, onClick, children, ...props }) => {
  return (
    <ListItemButton onClick={() => onClick(!checked)} {...props}>
      {primary && <ListItemText primary={primary} />}
      {children}
      <ColorSwitch edge="end" color={color} checked={checked} onClick={() => onClick(!checked)} />
    </ListItemButton>
  )
}

export default ToggleListItem
